import { request } from "../../Services/Api"
import { buildFormData, formDataHeaders } from "../../Utils/utils"

export const getUsers = (params) => request.api.get(`/user/`, params)
export const deleteUser = (userId) => request.api.delete(`/user/${userId}/`)
export const getUsersFilterOptions = () => request.api.get("/user/filter_options/")
export const getUsersExport = ({ file_name, ...params }) =>
  request.api.get(`/user/export_data/`, params)
export const sendGift = (params) => request.api.post(`/payments/balance-activity/gift/`, params)
export const switchUserToLoyalBilling = ({ userId, comment }) =>
  request.api.post(`/user/${userId}/switch_user_to_loyal_billing/`, { comment })

// Credit automation access (CHA1-3565) — admin / super admin only.
export const getCreditAutomationAccess = ({ user }) =>
  request.api.get(`/admin_panel/credit-automation/access/`, { user })
export const setCreditAutomationAccess = ({ user, is_granted }) =>
  request.api.post(`/admin_panel/credit-automation/access/`, { user, is_granted })

export const withDraw = (data) => {
  const formData = buildFormData(data, "file_list")
  return request.api.post(`/payments/balance-activity/withdrawal/`, formData, {
    headers: formDataHeaders
  })
}

export const getUserInfoComment = ({user_id}) => request.api.get(`/admin_panel/users/${user_id}/comments/info/`);
export const getUserComment = ({user_id, ba_id}) => {
  if (ba_id) {
    return request.api.get(`/admin_panel/users/${user_id}/comments/business-account/${ba_id}/`)
  } else {
    return request.api.get(`/admin_panel/users/${user_id}/comments/`)
  }
}
export const getUserBusinessAccountsList = ({user_id}) => request.api.get(`/admin_panel/users/${user_id}/comments/business-accounts/`);

export const saveComment = ({comment_id, user_id, ba_id, comment, ...data}) => {
  // The form field is named `comment`, but the API write serializer expects `comment_text`
  // (admin_panel UserCommentCreateUpdateSerializer). Map it so the text actually persists.
  const formData = buildFormData({...data, comment_text: comment}, 'file_list')
  if (comment_id) {
    if (ba_id) {
      return request.api.patch(`/admin_panel/users/${user_id}/comments/business-account/${ba_id}/`, formData, { headers: formDataHeaders })
    } else {
      return request.api.patch(`/admin_panel/users/${user_id}/comments/`, formData, { headers: formDataHeaders })
    }
  } else {
    if (ba_id) {
      return request.api.post(`/admin_panel/users/${user_id}/comments/business-account/${ba_id}/`, formData, { headers: formDataHeaders })
    } else {
      return request.api.post(`/admin_panel/users/${user_id}/comments/`, formData, { headers: formDataHeaders })
    }
  }
}

export const deleteUserComment = ({user_id, ba_id}) => {
  if (ba_id) {
    return request.api.delete(`/admin_panel/users/${user_id}/comments/business-account/${ba_id}/`)
  } else {
    return request.api.delete(`/admin_panel/users/${user_id}/comments/`)
  }
}

export const deleteUserCommentAttachment = ({user_id, comment_id, ...params }) => {
  return request.api.delete(`/admin_panel/users/${user_id}/comments/${comment_id}/attachments/delete/`, params)
}
